import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { t } from 'translation'

import AlarmModalDays from './AlarmModalDays'
import AlarmModalSongList from './AlarmModalSongList'
import AlarmModalTimePicker from './AlarmModalTimePicker'
import { addAlarm, editAlarm } from 'store/actions'

class AlarmModalSetAlarm extends Component {
  constructor(props) {
    super(props)

    const defaultState = {
      selectedTime: '12:00',
      selectedSongId: '',
      selectedDays: [false, true, true, true, true, true, false],
      isBtnAddFixed: false,
      alarmId: 0,
      isFocusedOnHoursPicker: false,
      isFocusedOnMinutesPicker: false,
    }

    if (props.editingAlarmId) {
      const alarmToEdit = props.alarms.find(
        ({ alarmInfo }) => alarmInfo.id === props.editingAlarmId
      )

      if (!alarmToEdit) this.state = defaultState
      else {
        const {
          alarmInfo: { time, days, id },
          songId,
        } = alarmToEdit

        this.state = {
          selectedTime: time,
          selectedSongId: songId,
          selectedDays: days,
          isBtnAddFixed: false,
          alarmId: id,
        }
      }
    } else {
      this.state = defaultState
    }
  }

  container = React.createRef()

  controlButton = React.createRef()

  inputHoursRef = React.createRef()

  inputMinutesRef = React.createRef()

  saveAlarmHandler = () => {
    //Time Today
    let today = new Date()
    let timeNow = today.getHours() + ':' + today.getMinutes()
    let nowHoursAndMinutes = timeNow.split(':')
    let nowMinutes = +nowHoursAndMinutes[0] * 60 + +nowHoursAndMinutes[1]

    //Alarm Time
    let alarmTimeSetup = new Date('1970-01-01 ' + this.state.selectedTime)
    let alarmTime = alarmTimeSetup.getHours() + ':' + alarmTimeSetup.getMinutes()
    let alarmHoursAndMinutes = alarmTime.split(':')
    let alarmMinutes = +alarmHoursAndMinutes[0] * 60 + +alarmHoursAndMinutes[1]

    //Day today
    let options = { weekday: 'long' }
    let dayToday = new Intl.DateTimeFormat('en-US', options).format(today)

    if (
      (dayToday == 'Sunday' &&
        this.state.selectedDays[0] == true &&
        alarmMinutes - nowMinutes <= 20 &&
        alarmMinutes - nowMinutes >= 0) ||
      (dayToday == 'Monday' &&
        this.state.selectedDays[1] == true &&
        alarmMinutes - nowMinutes <= 20 &&
        alarmMinutes - nowMinutes >= 0) ||
      (dayToday == 'Tuesday' &&
        this.state.selectedDays[2] == true &&
        alarmMinutes - nowMinutes <= 20 &&
        alarmMinutes - nowMinutes >= 0) ||
      (dayToday == 'Wednesday' &&
        this.state.selectedDays[3] == true &&
        alarmMinutes - nowMinutes <= 20 &&
        alarmMinutes - nowMinutes >= 0) ||
      (dayToday == 'Thursday' &&
        this.state.selectedDays[4] == true &&
        alarmMinutes - nowMinutes <= 20 &&
        alarmMinutes - nowMinutes >= 0) ||
      (dayToday == 'Friday' &&
        this.state.selectedDays[5] == true &&
        alarmMinutes - nowMinutes <= 20 &&
        alarmMinutes - nowMinutes >= 0) ||
      (dayToday == 'Saturday' &&
        this.state.selectedDays[6] == true &&
        alarmMinutes - nowMinutes <= 20 &&
        alarmMinutes - nowMinutes >= 0) ||
      (dayToday == 'Sunday' &&
        this.state.selectedDays[1] == true &&
        nowHoursAndMinutes[0] == 23 &&
        nowHoursAndMinutes[1] > 45 &&
        alarmHoursAndMinutes[0] == 0 &&
        alarmHoursAndMinutes[1] < 15) ||
      (dayToday == 'Monday' &&
        this.state.selectedDays[2] == true &&
        nowHoursAndMinutes[0] == 23 &&
        nowHoursAndMinutes[1] > 45 &&
        alarmHoursAndMinutes[0] == 0 &&
        alarmHoursAndMinutes[1] < 15) ||
      (dayToday == 'Tuesday' &&
        this.state.selectedDays[3] == true &&
        nowHoursAndMinutes[0] == 23 &&
        nowHoursAndMinutes[1] > 45 &&
        alarmHoursAndMinutes[0] == 0 &&
        alarmHoursAndMinutes[1] < 15) ||
      (dayToday == 'Wednesday' &&
        this.state.selectedDays[4] == true &&
        nowHoursAndMinutes[0] == 23 &&
        nowHoursAndMinutes[1] > 45 &&
        alarmHoursAndMinutes[0] == 0 &&
        alarmHoursAndMinutes[1] < 15) ||
      (dayToday == 'Thursday' &&
        this.state.selectedDays[5] == true &&
        nowHoursAndMinutes[0] == 23 &&
        nowHoursAndMinutes[1] > 45 &&
        alarmHoursAndMinutes[0] == 0 &&
        alarmHoursAndMinutes[1] < 15) ||
      (dayToday == 'Friday' &&
        this.state.selectedDays[6] == true &&
        nowHoursAndMinutes[0] == 23 &&
        nowHoursAndMinutes[1] > 45 &&
        alarmHoursAndMinutes[0] == 0 &&
        alarmHoursAndMinutes[1] < 15) ||
      (dayToday == 'Saturday' &&
        this.state.selectedDays[0] == true &&
        nowHoursAndMinutes[0] == 23 &&
        nowHoursAndMinutes[1] > 45 &&
        alarmHoursAndMinutes[0] == 0 &&
        alarmHoursAndMinutes[1] < 15)
    ) {
      alert(t('alarm.TIME_WARNING'))
    } else {
      const alarmToSave = {
        songId: this.state.selectedSongId,
        alarmInfo: { time: this.state.selectedTime, days: this.state.selectedDays },
      }

      this.props.editingAlarmId
        ? this.props.editAlarm(alarmToSave, this.props.editingAlarmId)
        : this.props.addAlarm(alarmToSave)

      this.props.closeAlarmCreationHandler()
    }
  }

  selectDayHandler = (dayNumber) => {
    this.setState(({ selectedDays }) => {
      const updatedSelectedDays = [...selectedDays]
      updatedSelectedDays[dayNumber] = !selectedDays[dayNumber]
      return { selectedDays: updatedSelectedDays }
    })
  }

  selectSongHandler = (selectedSongId) => this.setState({ selectedSongId })

  selectHoursHandler = (selectedHours) => {
    if (selectedHours)
      this.setState((prevState) => ({
        selectedTime: `${selectedHours}:${prevState.selectedTime.slice(3)}`,
      }))
  }

  selectMinutesHandler = (selectedMinutes) => {
    if (selectedMinutes)
      this.setState((prevState) => ({
        selectedTime: `${prevState.selectedTime.slice(0, 2)}:${selectedMinutes}`,
      }))
  }

  setBtnControlFixed() {
    if (!this.container.current || !this.controlButton.current) return

    const containerHeight = this.container.current.offsetHeight
    const controlButtonHeight = this.controlButton.current.offsetHeight

    if (this.state.isBtnAddFixed) {
      // Need to add control button height when button is fixed and
      // removed from height of container to prevent infinite loop
      // when difference in height is close to button height
      if (containerHeight + controlButtonHeight < window.innerHeight) {
        this.controlButton.current.classList.remove('fixed_mod')
        this.setState({
          isBtnAddFixed: false,
        })
      }
    } else {
      if (containerHeight >= window.innerHeight) {
        this.controlButton.current.classList.add('fixed_mod')
        this.setState({
          isBtnAddFixed: true,
        })
      }
    }
  }

  setIsHoursPickerFocusedHandler = (isFocusedOnHours, hoursEl) => {
    if (!this.hoursEl && hoursEl) this.hoursEl = hoursEl
    if (this.hoursEl)
      isFocusedOnHours
        ? this.hoursEl.classList.add('focused')
        : this.hoursEl.classList.remove('focused')
  }

  setIsMinutesPickerFocusedHandler = (isFocusedOnMinutes, minutesEl) => {
    if (!this.minutesEl && minutesEl) this.minutesEl = minutesEl
    if (this.minutesEl)
      isFocusedOnMinutes
        ? this.minutesEl.classList.add('focused')
        : this.minutesEl.classList.remove('focused')
  }

  selectTimeHandler = (selectedTime) => {
    if (selectedTime) this.setState({ selectedTime })
  }

  componentDidMount() {
    this.setBtnControlFixed()
  }

  componentDidUpdate() {
    this.setBtnControlFixed()
  }

  render() {
    const canSaveAlarm = this.state.selectedDays.some((day) => day)
    return (
      <div
        className="popup alarm_mod"
        onClick={(e) => {
          this.setIsHoursPickerFocusedHandler(false)
          this.setIsMinutesPickerFocusedHandler(false)
          if (this.inputHoursRef) this.inputHoursRef.current.blur()
          if (this.inputMinutesRef) this.inputMinutesRef.current.blur()
          if (e) e.stopPropagation()
        }}
      >
        <button
          className="close_btn right_pos_mod alarm_mod"
          onClick={this.props.closeModalHandler}
        ></button>
        <div className="popup_in" ref={this.container}>
          <div className="popup_content">
            <h2 className="section_title offset_mod alarm_mod">{t('alarm.SET_ALARM')}</h2>
          </div>
          <div className="alarm_container sm_mod">
            <div className="alarm_heading">
              <div
                className={`alarm_heading_timer ${
                  this.state.isFocusedOnHoursPicker ? 'focused' : ''
                }`}
              >
                <AlarmModalTimePicker
                  selectedTime={this.state.selectedTime}
                  selectHoursHandler={this.selectHoursHandler}
                  selectMinutesHandler={this.selectMinutesHandler}
                  selectTimeHandler={this.selectTimeHandler}
                  inputHoursRef={this.inputHoursRef}
                  inputMinutesRef={this.inputMinutesRef}
                  setIsHoursPickerFocusedHandler={this.setIsHoursPickerFocusedHandler}
                  setIsMinutesPickerFocusedHandler={this.setIsMinutesPickerFocusedHandler}
                />
              </div>
              <AlarmModalDays
                activeDays={this.state.selectedDays}
                isSelectable
                selectDayHandler={this.selectDayHandler}
              />
            </div>
            <AlarmModalSongList
              selectSongHandler={this.selectSongHandler}
              selectedSongId={this.state.selectedSongId}
            />
            <div className="alarm_btn_wrap" ref={this.controlButton}>
              <button
                className="btn_add"
                onClick={this.saveAlarmHandler}
                disabled={!canSaveAlarm}
              >
                {t('alarm.SAVE')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ alarm: { alarms } }) => ({
  alarms,
})

const willMapDispatchToProps = { addAlarm, editAlarm }

export default connect(mapStateToProps, willMapDispatchToProps)(AlarmModalSetAlarm)

AlarmModalSetAlarm.propTypes = {
  alarms: PropTypes.array.isRequired,
  addAlarm: PropTypes.func.isRequired,
  closeAlarmCreationHandler: PropTypes.func.isRequired,
  closeModalHandler: PropTypes.func.isRequired,
  editingAlarmId: PropTypes.number.isRequired,
}
